<template>
    <Link
        :href="l.link"
        @click="$emit('clicked', index)"
        :class="[
            'nav-link anim',
            {
                active:
                    $page.component === l.component ||
                    ($page.component?.indexOf('MBB') == 0 &&
                        l.component?.indexOf('MBB') == 0 &&
                        this.$options.name == 'NavigationLink'),
            },
        ]"
    >
        <img
            v-if="l.icon"
            :src="`/images/icons/${l.icon}`"
            class="icon z-20 h-6 w-6 origin-center"
            aria-hidden="true"
            :alt="l.label"
        />
        <img
            v-if="l.icon && l.icon != 'adam-wood.svg'"
            :src="`/images/icons/${l.icon}`"
            class="z-10 mb-2 h-2 w-8 origin-center shadow"
            aria-hidden="true"
            :alt="l.label"
        />
        <img
            v-else
            :src="`/images/icons/tv.png`"
            class="z-10 mb-2 h-2 w-10 origin-center shadow"
            aria-hidden="true"
            :alt="l.label"
        />
        <div
            class="label whitespace-nowrap pl-0 text-center text-sm font-bold uppercase"
        >
            {{ l.label }}
        </div>
    </Link>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
    name: 'NavigationLink',
    emits: ['clicked'],
    components: { Link },
    props: ['l', 'index'],
    computed: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
